import AppTheme from "../../../frontend/shared-theme/AppTheme";
import type { } from '@mui/x-date-pickers/themeAugmentation';
import type { } from '@mui/x-charts/themeAugmentation';
import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import type { } from '@mui/x-tree-view/themeAugmentation';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from '../../components/AppNavbar';
import Header from '../../components/Header';
import SideMenu from '../../components/SideMenu';
import { Container, Divider, Typography } from "@mui/material";
import { useColorScheme } from '@mui/material/styles';
import Footer from "../../../frontend/components/Footer";
import { useEffect, useState } from "react";
import { auth } from "../../../contexts/authentication";
import AppAppBar from "../../../frontend/components/AppAppBar";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export default function TermsPolicy(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <TermsPolicyContent />
    </AppTheme>
  )
}

function TermsPolicyContent() {
  const { mode, systemMode } = useColorScheme();

  return (
    <>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <AppAppBar />
        <Box
          id="hero"
          sx={(theme) => ({
            width: '100%',
            backgroundRepeat: 'no-repeat',

            backgroundImage:
              'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
            ...theme.applyStyles('dark', {
              backgroundImage:
                'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
            }),
          })}
        >
          <Box>
            <Stack
              spacing={2}
              sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
            </Stack>
            <Container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pt: 10,
                pb: { xs: 8, sm: 12 },
              }}
            >
              <Stack
                spacing={2}
                useFlexGap
                sx={{ alignItems: 'center', width: '100%' }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    fontSize: '3rem',
                  }}
                >
                  Termos de&nbsp;
                  <Typography
                    component="span"
                    variant="h1"
                    sx={(theme) => ({
                      fontSize: 'inherit',
                      color: 'primary.main',
                      ...theme.applyStyles('dark', {
                        color: 'primary.light',
                      }),
                    })}
                  >
                    Uso e Políticas
                  </Typography>
                </Typography>
              </Stack>
            </Container>
            <Container sx={{ display: 'flex', flexDirection: 'column', gap: 4, pl: '2 !important' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h4">
                  <strong>Boas vindas ao Nextalk - CABANA</strong><span style={{ fontWeight: 'normal' }}>LINK</span>
                </Typography>
                <Typography color="textSecondary" pl={2} pr={2}>
                  A CABANA LINK oferece serviços digitais de automatização
                  e gestão de processos. Ao utilizar nossos serviços, você concorda com estes termos.
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                  Política de Cancelamento
                </Typography>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
                  color='text.secondary'
                >
                  <Box pl={2} pr={2}>
                    <strong>Garantia de Satisfação:</strong> Conforme
                    Artigo 49 do Código de Defesa do Consumidor, o cliente
                    possui <strong>7 dias corridos</strong> após
                    a confirmação do pagamento para solicitar cancelamento e reembolso integral.
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: mode === 'dark' || systemMode === 'dark' ?
                        'hsl(208, 100.00%, 3.30%)' : 'hsl(210, 100.00%, 96.90%)',
                      p: 2,
                      borderRadius: 1
                    }}
                  >
                    Para cancelamentos entre em contato dentro do prazo com nosso suporte:
                    <Box>E-mail: <strong>suporte@cabanalink.com</strong></Box>
                    <Box>WhatsApp: <strong>(22) 98100-7438</strong></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                  Regime de Responsabilidades
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <Stack color='text.secondary' sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="button" pl={2}>
                      <strong>Obrigações da Contratada</strong>
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography pl={2}>
                        Armazenar dados e
                        implementar sistemas de segurança compatíveis com a LGPD, conforme
                        estabelecido na Lei 13.709/2018.
                      </Typography>
                      <Box
                        sx={{
                          backgroundColor: mode === 'dark' || systemMode === 'dark' ?
                            'hsl(208, 100.00%, 3.30%)' : 'hsl(210, 100.00%, 96.90%)',
                          p: 2,
                          borderRadius: 1
                        }}
                      >
                        <Typography>Manter disponibilidade operacional, exceto em casos de:</Typography>
                        <Box pl={2}>
                          <Typography component='li' variant="caption">Manutenções programadas</Typography>
                          <Typography component='li' variant="caption">Casos fortuitos ou força maior</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Stack>
                  <Stack color='text.secondary' sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="button" pl={2}>
                      <strong>Obrigações do Contratante</strong>
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography pl={2}>
                        Zelar pela confidencialidade das credenciais de acesso,
                        responsabilizar-se civil e criminalmente pelo conteúdo armazenado e
                        notificar imediatamente sobre qualquer violação de segurança são as obrigações do usuário.
                      </Typography>
                      <Box
                        sx={{
                          backgroundColor: mode === 'dark' || systemMode === 'dark' ?
                            'hsl(208, 100.00%, 3.30%)' : 'hsl(210, 100.00%, 96.90%)',
                          p: 2,
                          borderRadius: 1
                        }}
                      >
                        <Typography>Além de abster-se de práticas que:</Typography>
                        <ul>
                          <Typography component='li' variant="caption">
                            Violem direitos de propriedade intelectual
                          </Typography>
                          <Typography component='li' variant="caption">
                            Caracterizem uso indevido de recursos computacionais
                          </Typography>
                          <Typography component='li' variant="caption">
                            Configurem atividades ilícitas conforme
                            Lei 12.965/14 (Marco Civil da Internet)
                          </Typography>
                        </ul>
                      </Box>
                    </Box>
                  </Stack>
                  <Stack color='text.secondary' sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="button" pl={2}>
                      <strong>Limitações de Responsabilidade</strong>
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pl: 2 }}>
                      <Typography>
                        Não nos responsabilizamos por
                        perdas indiretas ou lucros cessantes,
                        danos decorrentes de má utilização da plataforma,
                        interrupções causadas por terceiros não subordinados à nossa gestão direta.
                      </Typography>
                      <Typography>
                        Nosso dever de indenização, dentro do prazo de arrependimento, limita-se ao valor pago pelo serviço.
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Box>
              {/* <Divider /> */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                  Política de Pagamento
                </Typography>
                <Box
                  sx={{
                    backgroundColor: mode === 'dark' || systemMode === 'dark' ?
                      'hsl(208, 100.00%, 3.30%)' : 'hsl(210, 100.00%, 96.90%)',
                    p: 2,
                    borderRadius: 1,
                    color: 'text.secondary'
                  }}
                >
                  <Box sx={{ display: 'flex', gap: 1,}}>
                    <CheckCircleIcon sx={{ color: 'success.main', fontSize: 'medium', mt: 0.5 }} />
                    <Typography>Cobrança recorrente conforme o prazo do plano escolhido.</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <CheckCircleIcon sx={{ color: 'success.main', fontSize: 'medium', mt: 0.5 }} />
                    <Typography>Meio de pagamento disponível automaticamente em nosso sistema.</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <CancelIcon sx={{ color: 'error.main', fontSize: 'medium', mt: 0.5 }} />
                    <Typography>
                      Não aceitamos chargeback - utilize os canais oficiais para
                      cancelamentos dentro do prazo de arrependimento.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* <Divider /> */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                  Disposições Finais
                </Typography>
                <Box component="ul" sx={{ display: 'flex', flexDirection: 'column', gap: 1, color: 'text.secondary' }}>
                  <Box component="li">Estes termos são regidos pelas leis da República Federativa do Brasil.</Box>
                  <Box component="li">Controvérsias são dirimidas no Foro da Comarca do Rio de Janeiro/RJ.</Box>
                  <Box component="li">Reservamo-nos o direito de atualizar estes termos quando se fizer indispensável.</Box>
                  <Box component="li">Cláusulas nulas não invalidam o restante do instrumento.</Box>
                </Box>
              </Box>
            </Container>
          </Box>
          <Divider sx={{ mt: 5 }} />
          <Footer />
        </Box>
      </Box >
    </>
  );
}